import { render, staticRenderFns } from "./AdditionsDeductionsSection.vue?vue&type=template&id=9b4cb7aa&scoped=true&"
import script from "./AdditionsDeductionsSection.vue?vue&type=script&lang=js&"
export * from "./AdditionsDeductionsSection.vue?vue&type=script&lang=js&"
import style0 from "./AdditionsDeductionsSection.vue?vue&type=style&index=0&id=9b4cb7aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4cb7aa",
  null
  
)

export default component.exports